/**
 * Тонкая обёртка над Telegram WebApp API. Через официальный SDK не идём:
 * нужен ровно этот набор вызовов, а глобальный объект доступен всегда,
 * когда мини-апп открыт внутри клиента.
 */

interface HapticFeedback {
  impactOccurred(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'): void;
  notificationOccurred(type: 'error' | 'success' | 'warning'): void;
  selectionChanged(): void;
}

interface BackButton {
  show(): void;
  hide(): void;
  onClick(handler: () => void): void;
  offClick(handler: () => void): void;
}

interface MainButton {
  setParams(params: { text?: string; is_visible?: boolean; is_active?: boolean }): void;
  onClick(handler: () => void): void;
  offClick(handler: () => void): void;
  showProgress(leaveActive?: boolean): void;
  hideProgress(): void;
}

interface TelegramWebApp {
  initData: string;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  ready(): void;
  expand(): void;
  close(): void;
  HapticFeedback?: HapticFeedback;
  BackButton: BackButton;
  MainButton: MainButton;
  showAlert(message: string, callback?: () => void): void;
  showConfirm(message: string, callback: (confirmed: boolean) => void): void;
  disableVerticalSwipes?(): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export const webApp = (): TelegramWebApp | null => window.Telegram?.WebApp ?? null;

export const isInsideTelegram = (): boolean => Boolean(webApp()?.initData);

export function initTelegram(): void {
  const app = webApp();
  if (!app) return;
  app.ready();
  app.expand();
  // Свайп вниз внутри списка отзывов не должен закрывать мини-апп.
  app.disableVerticalSwipes?.();
}

export const haptic = {
  tap(): void {
    webApp()?.HapticFeedback?.impactOccurred('light');
  },
  success(): void {
    webApp()?.HapticFeedback?.notificationOccurred('success');
  },
  error(): void {
    webApp()?.HapticFeedback?.notificationOccurred('error');
  },
  select(): void {
    webApp()?.HapticFeedback?.selectionChanged();
  },
};

export function confirm(message: string): Promise<boolean> {
  const app = webApp();
  if (!app) return Promise.resolve(window.confirm(message));
  return new Promise((resolve) => app.showConfirm(message, resolve));
}

export function alert(message: string): void {
  const app = webApp();
  if (app) app.showAlert(message);
  else window.alert(message);
}

/** initData для входа. Вне Telegram отдаём заглушку из env — удобно для локальной вёрстки. */
export function getInitData(): string {
  return webApp()?.initData || (import.meta.env['VITE_DEV_INIT_DATA'] as string | undefined) || '';
}
